import {
  createLinkTemplate,
  createLinkTemplateWithParams,
  prefixLinkTemplate
} from "./link-template-helpers";
import {
  template_term_bus,
  template_term_bus_company,
  template_term_train
} from "./link-template-terms";

export const home_link_template = "/{locale}";
export const busbud_home_link_template = "https://www.busbud.com/{locale}";
export const about_link_template = "/{locale}/about";
export const about_partners_link_template = "/{locale}/about/partners";
export const affiliate_link_template = createLinkTemplate(
  "https://www.busbud.com/en/affiliate",
  {
    overrides: {
      "en-ca": "https://www.busbud.com/en-ca/affiliate",
      es: "https://www.busbud.com/es/affiliate",
      "es-419": "https://www.busbud.com/es/affiliate",
      "es-mx": "https://www.busbud.com/es/affiliate",
      "fr-ca": "https://www.busbud.com/fr-ca/affiliate"
    }
  }
);
export const distribution_link_template = createLinkTemplate(
  "https://www.busbud.com/en/distribution",
  {
    overrides: {
      "en-ca": "https://www.busbud.com/en-ca/distribution",
      es: "https://www.busbud.com/es/distribution",
      "es-419": "https://www.busbud.com/es/distribution",
      "es-mx": "https://www.busbud.com/es/distribution",
      fr: "https://www.busbud.com/fr/distribution",
      "fr-ca": "https://www.busbud.com/fr-ca/distribution"
    }
  }
);
export const terms_of_use_link_template =
  "https://www.busbud.com/{locale}/terms-of-use/";
export const privacy_link_template =
  "https://www.busbud.com/{locale}/privacy-policy/";
export const refunds_link_template =
  "https://www.busbud.com/{locale}/refund-policy/";
export const press_link_template = "/{locale}/about/press";
export const careers_link_template = "/{locale}/careers/";
export const bus_partners_link_template = "/partner/supply/";
export const impressum_link_template = "/{locale}/about/impressum";
export const instagram_link_template = "https://www.instagram.com/busbud/";
export const facebook_link_template = "https://www.facebook.com/Busbud";
export const twitter_link_template = "https://x.com/Busbud";
// TODO: affiliate products are not completely localized
export const affiliate_products_link_template = createLinkTemplate(
  "https://www.busbud.com/partner",
  {
    overrides: {
      es: "https://www.busbud.com/partner/es/",
      fr: "https://www.busbud.com/partner/fr/",
      "fr-ca": "https://www.busbud.com/partner/fr/"
    }
  }
);
export const contact_link_template = "/{locale}/contact";
// TODO: Blog is not completely localized
export const blog_link_template = createLinkTemplate(
  "https://www.busbud.com/blog/",
  {
    overrides: {
      es: "https://www.busbud.com/blog/es/pagina-principal/",
      "es-419": "https://www.busbud.com/blog/es/pagina-principal/",
      "es-mx": "https://www.busbud.com/blog/es/pagina-principal/",
      fr: "https://www.busbud.com/blog/fr/accueil/",
      "fr-ca": "https://www.busbud.com/blog/fr/accueil/",
      pt: "https://www.busbud.com/blog/pagina-inicial/",
      "pt-pt": "https://www.busbud.com/blog/pagina-inicial/"
    }
  }
);
export const stop_keyword_link_template = createLinkTemplate(
  locale => `/${locale}/{keyword}/s/{id}`
);
export const partner_link_template = createLinkTemplateWithParams(
  { bus_company: template_term_bus_company },
  (locale, { bus_company }) => `/${locale}/${bus_company}/{url_form}`
);
export const operator_link_template = "/{locale}/o/{url_form}";
export const operator_awards_template = "/{language}/operator-awards";
export const results_link_template = createLinkTemplate(
  locale =>
    `/${locale}/bus-schedules-results/{origin_geohash}/{destination_geohash}`
);
export const deeplink_link_template = createLinkTemplate(
  locale =>
    `/${locale}/deeplink/{origin_geohash}/{destination_geohash}/{outbound_id}/{return_id}`
);
export const route_link_template = createLinkTemplateWithParams(
  { bus: template_term_bus },
  (locale, { bus }) =>
    `/${locale}/${bus}-{origin_name}-{destination_name}/r/{origin_geohash}-{destination_geohash}`
);
export const route_sem_link_template = createLinkTemplateWithParams(
  { bus: template_term_bus },
  (locale, { bus }) =>
    `/${locale}/{origin_country}-{destination_country}/${bus}-{origin_name}-{destination_name}/r-sem/{origin_geohash}-{destination_geohash}`
);
export const point_of_interest_link_template = createLinkTemplate(
  locale => `/${locale}/poi/{keyword}/{id}`
);
export const point_of_interest_route_link_template =
  createLinkTemplateWithParams(
    { bus: template_term_bus },
    (locale, { bus }) =>
      `/${locale}/${bus}-{origin_name}-{destination_name}/i/{origin}-{destination}`
  );
export const multimodal_route_link_template = createLinkTemplate(
  locale =>
    `/${locale}/{origin_name}-{destination_name}/m/{origin}-{destination}`
);
export const train_route_keyword_link_template = createLinkTemplateWithParams(
  { train: template_term_train },
  (locale, { train }) =>
    `/${locale}/${train}-{origin_name}-{destination_name}/t/{origin_geohash}-{destination_geohash}`
);

export const route_androidapp_link_template = prefixLinkTemplate(
  route_link_template,
  "android-app://com.busbud.android/https/www.busbud.com"
);
export const city_link_template = createLinkTemplateWithParams(
  { bus: template_term_bus },
  (locale, { bus }) => `/${locale}/${bus}-{name}/c/{geohash}`
);
export const trains_to_link_template = createLinkTemplateWithParams(
  { train: template_term_train },
  (locale, { train }) => `/${locale}/${train}-{name}/ct/{geohash}`
);

export const city_sem_link_template = createLinkTemplateWithParams(
  { bus: template_term_bus },
  (locale, { bus }) => `/${locale}/{country}/${bus}-{name}/c-sem/{geohash}`
);
export const sitemap_link_template = {
  routes: {
    index: "/{locale}/sitemap/wr/0",
    country: "/{locale}/sitemap/c/{country_code2}"
  },
  stops: {
    index: "/{locale}/sitemap/ws/0",
    country: "/{locale}/sitemap/cs/{country_code2}",
    city: "/{locale}/sitemap/is/{city_geohash}"
  },
  points_of_interest: {
    index: "/{locale}/sitemap/wpoi/0",
    country: "/{locale}/sitemap/cpoi/{country_code2}",
    city: "/{locale}/sitemap/ipoi/{city_geohash}"
  },
  cities: {
    index: "/{locale}/sitemap/wc/0",
    country: "/{locale}/sitemap/cc/{country_code2}"
  },
  trains_to: {
    index: "/{locale}/sitemap/wct/0",
    country: "/{locale}/sitemap/cct/{country_code2}"
  },
  partners: {
    index: "/{locale}/sitemap/wp/0"
  },
  service_disruptions: {
    index: "/{locale}/sitemap/td/0"
  }
};
export const sitemap_keyword_link_template = {
  routes: {
    index: "/{locale}/sitemap/{keyword}/wr/0",
    country: "/{locale}/sitemap/{keyword}/c/{country_code2}"
  },
  stops: {
    index: "/{locale}/sitemap/{keyword}/ws/0",
    country: "/{locale}/sitemap/{keyword}/cs/{country_code2}",
    city: "/{locale}/sitemap/{keyword}/is/{city_geohash}"
  },
  cities: {
    country: "/{locale}/sitemap/{keyword}/cc/{country_code2}"
  },
  partners: {
    index: "/{locale}/sitemap/{keyword}/wp/0"
  }
};
export const country_link_template = "/{locale}/country/{country_code2}";
export const help_link_template = createLinkTemplate(
  "https://help.busbud.com/hc/en-us",
  {
    overrides: {
      de: "https://help.busbud.com/hc/de",
      es: "https://help.busbud.com/hc/es",
      "es-419": "https://help.busbud.com/hc/es",
      "es-mx": "https://help.busbud.com/hc/es",
      fr: "https://help.busbud.com/hc/fr",
      "fr-ca": "https://help.busbud.com/hc/fr",
      it: "https://help.busbud.com/hc/it",
      pt: "https://help.busbud.com/hc/pt-br",
      "pt-pt": "https://help.busbud.com/hc/pt-br",
      ru: "https://help.busbud.com/hc/ru",
      tr: "https://help.busbud.com/hc/tr"
    }
  }
);
export const search_link_template = {
  submit: "/{locale}/search/submit"
};
export const checkout_link_template = {
  index: "/{locale}/checkout",
  referral: "/{locale}/checkout/referral/{referral_cart_id}"
};
export const thank_you_link_template = {
  index: "/{locale}/thank-you/{purchase_id}"
};
export const purchase_unsuccessful_link_template = {
  index: "/{locale}/purchase-unsuccessful/{purchase_id}"
};
export const account_link_template = {
  logout: "/{locale}/auth/logout",
  loyalty_profile: "/{locale}/account/profile",
  passenger_profiles: "/{locale}/account/passenger-profiles",
  profile: "/{locale}/account/trips",
  settings: "/{locale}/account/settings",
  signin: "/{locale}/account/signin",
  signup: "/{locale}/account/signup",
  trip: "/{locale}/account/trips/{purchase_id}",
  trips: "/{locale}/account/trips",
  forgot_password: "/{locale}/account/forgot-password"
};
export const error404_link_template = "/{locale}/404";
export const image_link_template = "https://busbud.imgix.net/";
export const typeform_survey_link_template = {
  rating: {
    de: "https://busbudsurveys.typeform.com/to/W6fwAB",
    en: "https://busbudsurveys.typeform.com/to/iivPVl",
    "en-ca": "https://busbudsurveys.typeform.com/to/iivPVl",
    "en-gb": "https://busbudsurveys.typeform.com/to/iivPVl",
    es: "https://busbudsurveys.typeform.com/to/vhfT11",
    "es-419": "https://busbudsurveys.typeform.com/to/vhfT11",
    "es-mx": "https://busbudsurveys.typeform.com/to/vhfT11",
    fr: "https://busbudsurveys.typeform.com/to/SOwOHg",
    "fr-ca": "https://busbudsurveys.typeform.com/to/SOwOHg",
    it: "https://busbudsurveys.typeform.com/to/MJzxTh",
    nl: "https://busbudsurveys.typeform.com/to/kHrFq2",
    pl: "https://busbudsurveys.typeform.com/to/uCXpDI",
    pt: "https://busbudsurveys.typeform.com/to/gi7xDR",
    "pt-pt": "https://busbudsurveys.typeform.com/to/gi7xDR",
    ru: "", // FIXME
    sv: "https://busbudsurveys.typeform.com/to/UtazGL",
    tr: "https://busbudsurveys.typeform.com/to/wQsUf9",
    zh: "https://busbudsurveys.typeform.com/to/TLLEO1"
  }
};
export const terms_link_template =
  "/{locale}/terms/{ticket_type}/{departure_id}";
export const third_party_link_template = {
  booking_com_search:
    "https://sp.booking.com/searchresults.html?aid={aid}&checkin={checkin_date}&checkout={checkout_date}&dest_id={dest_id}&dest_type=city&lang={lang}&selected_currency={currency}&label=device_id%3D{device_id}&group_adults={adults}",
  booking_com_demand_api: "https://demandapi.booking.com/3.1"
};
export const google_maps_link_template =
  "https://www.google.com/maps/search/?api=1&query={lat},{lon}";
